import { Button } from "../../../components/ui/Button";
import { api } from "../../../lib/api/endpoints";
import { IMAGE_TYPES } from "../../editor/images";

export function LogoPicker({
  label,
  value,
  onUpload,
  onChange,
  readOnly = false,
}: {
  label: string;
  value: string;
  onUpload: (file: File) => void;
  onChange: (src: string) => void;
  readOnly?: boolean;
}) {
  return (
    <fieldset aria-label={label} className="grid min-w-0 grid-cols-1 gap-2 rounded-lg border border-line p-3">
      <legend className="px-1 text-sm font-medium text-ink-2">{label}</legend>
      <div className="flex h-16 items-center justify-center rounded-md bg-column">
        {value.startsWith("att:") ? (
          <img src={api.attachments.url(value)} alt={label} className="max-h-14 max-w-full" />
        ) : (
          <span className="text-sm text-ink-3">Built-in Klarity logo</span>
        )}
      </div>
      {readOnly ? null : (
        <div className="flex flex-wrap items-center gap-2">
          <Button
            size="sm"
            disabled={value === "builtin:klarity-logo"}
            onClick={() => onChange("builtin:klarity-logo")}
          >
            Use the built-in logo
          </Button>
          <label className="text-xs text-ink-2">
            Upload an image
            <input
              type="file"
              accept={IMAGE_TYPES.join(",")}
              className="ml-2 text-xs"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) onUpload(file);
                e.target.value = "";
              }}
            />
          </label>
        </div>
      )}
    </fieldset>
  );
}
